import React from 'react';

import CONSTANTS from '../../../constants/index';

import contactStyles from './ContactUs.scss';

const ContactUs = () => {
  return (
    <div className={contactStyles.container}>
      <p className={contactStyles.needHelp}>Need help signing up?</p>
      <a
        className={contactStyles.contactUs}
        href={`mailto:${CONSTANTS.QM_SUPPORT_EMAIL}`}
      >
        Contact Us
      </a>
    </div>
  );
};

export default ContactUs;
